module.exports = __webpack_public_path__ + "img/w50b.0f10cfb2.jpg";